import { Component, Input, AfterContentInit, forwardRef, ElementRef, Output, EventEmitter, AfterViewInit, ViewChild, OnInit  } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';


@Component({
    selector: 'custom-input-persisted',
    host: {
        '[class.rundnaDropdown]': 'someAttr',
    },
    template: `
    <kendo-textbox class="{{cssClass}}" [(ngModel)]="selectedValue"  placeholder="{{placeholder}}" (valueChange)="onChange($event)" (blur)="onBlur()" [disabled]="disabled" [clearButton]="true"></kendo-textbox>
  `,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CustomInputPersistedControl),
            multi: true
        }
    ]
})

export class CustomInputPersistedControl implements ControlValueAccessor, OnInit {

    someAttr: string = 'anyValue';
    selectedValue: any;
    localStorageKey: string;

    constructor(private elementRef: ElementRef) {
        this.cssClass = elementRef.nativeElement.getAttribute('class');
        elementRef.nativeElement.setAttribute('class', '');
    }

    @Input()
    placeholder: string = null;

    @Input()
    key: string = null;

    @Input()
    disabled: boolean = false;

    @Output()
    valueChange = new EventEmitter<number>();

    @Output()
    blur = new EventEmitter<number>();


    cssClass: string = '';

    propagateChange = (_: any) => { };
    propagateTouch = () => { };

    writeValue(value: any): void {
        this.selectedValue = value;
    }

    registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.propagateTouch = fn;
    }

    onChange(value: any) {
        this.writeValue(value);
        this.propagateChange(this.selectedValue);
        this.propagateTouch();
        if (this.localStorageKey) {
          localStorage.setItem(this.localStorageKey, value);
        }
        this.valueChange.emit(value);
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    onBlur() {
      this.blur.emit(this.selectedValue);
    }

    ngOnInit(): void {
      // if there is a key and a persisted value, default the field to that
      this.localStorageKey = this.key ? 'rundna-persistedInput-' + this.key : null;
      if (this.localStorageKey && localStorage.getItem(this.localStorageKey)) {
        this.onChange(localStorage.getItem(this.localStorageKey));
      }
    }
}
